import { httpClient } from "@adapters/api/HttpClient";
import { AxiosResponse } from "axios";

export const reportingServices = {
  error: async (error: string): Promise<AxiosResponse<Record<string, never>>> => {
    return httpClient.post("/v1/reporting/error", { error });
  },
};
